import { render, staticRenderFns } from "./print-table.vue?vue&type=template&id=1fbfafec&scoped=true"
import script from "./print-table.vue?vue&type=script&lang=js"
export * from "./print-table.vue?vue&type=script&lang=js"
import style0 from "./print-table.vue?vue&type=style&index=0&id=1fbfafec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbfafec",
  null
  
)

export default component.exports